import { render, staticRenderFns } from "./FutureProfessionsCard.vue?vue&type=template&id=4e3b589f&scoped=true"
import script from "./FutureProfessionsCard.vue?vue&type=script&lang=ts"
export * from "./FutureProfessionsCard.vue?vue&type=script&lang=ts"
import style0 from "./FutureProfessionsCard.vue?vue&type=style&index=0&id=4e3b589f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3b589f",
  null
  
)

export default component.exports